import {
    ANALYZE_OVERVIEW,
    ANALYZE_ENGAGEMENT,
    CONTENT_POSTS,
    DASHBOARD,
    DASHBOARD_VIEW,
    DASHBOARD_CUSTOMIZATION,
    DASHBOARD_GENERATE_CUSTOM_REPORT,
    REPORTS,
    REPORTS_EDIT,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    ANALYZE_CONTENT,
    CONTENT_ALBUMS,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_ANALYTICS,
    SUBSCRIPTION_INVOICES,
    CONTENT_ALBUMS_COMPARATIVE_TABLE,
    INSPIRATION,
    CONTENT_ALBUM_STATS
} from '@/routes/privateRoutes';

//lib
import { CAMPAIGNS_QUERY_ACTION_PARAM } from '@/lib/albums/queryParams';
import {
    DASHBOARD as DASHBOARD_RIGHT,
    TIKTOK_PUBLISHING_HAS_ACCESS
} from '@/lib/acl/aclRightsList';
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';
import type { MainMenuType } from '@/lib/menu/main';

//Components
import LinkBase from '@/components/base/LinkBase';
import {
    GLOBAL_EVENT_QUERY,
    GLOBAL_EVENT_TYPES
} from '@/components/composite/Listeners/GlobalEventsListener';

const mainTiktok: MainMenuType = [
    // Dashboard
    {
        icon: 'dashboard',
        link: DASHBOARD,
        name: 'commons:menu.dashboard',
        locked: DASHBOARD_RIGHT.read,
        urlActiveMenu: [DASHBOARD_VIEW, DASHBOARD_CUSTOMIZATION, DASHBOARD_GENERATE_CUSTOM_REPORT],
        discoverId: 'dashboard'
    },
    // Analytics
    {
        icon: 'analytics',
        name: 'menu.analytics',
        subMenuItems: [
            {
                icon: 'eye',
                link: ANALYZE_OVERVIEW,
                name: 'commons:menu.overview'
            },
            {
                icon: 'engagement',
                link: ANALYZE_ENGAGEMENT,
                name: 'commons:menu.engagement'
            },
            {
                icon: 'content',
                link: ANALYZE_CONTENT,
                name: 'commons:menu.content'
            }
        ]
    },
    // Reports
    {
        icon: 'reports',
        link: REPORTS,
        name: 'commons:menu.exports_reports',
        urlActiveMenu: [
            REPORTS_EDIT,
            REPORTS_ACCOUNTS,
            REPORTS_DASHBOARDS,
            REPORTS_COMPETITORS,
            REPORTS_HASHTAGS
        ]
    },
    // Content
    {
        icon: 'content',
        name: 'commons:menu.content',
        quickAccess: {
            label: 'commons:menu.track_campaign',
            icon: 'plus',
            link: {
                pathname: CONTENT_ALBUMS,
                query: {
                    [CAMPAIGNS_QUERY_ACTION_PARAM.NAME]:
                        CAMPAIGNS_QUERY_ACTION_PARAM.VALUES.TRACK_CAMPAIGN
                }
            }
        },
        subMenuItems: [
            {
                icon: 'content',
                link: CONTENT_POSTS,
                name: 'commons:menu.posts'
            },
            {
                icon: 'albums',
                link: CONTENT_ALBUMS,
                name: 'commons:menu.albums',
                urlActiveMenu: [
                    CONTENT_ALBUM_POSTS,
                    CONTENT_ALBUM_ANALYTICS,
                    CONTENT_ALBUM_STATS,
                    CONTENT_ALBUMS_COMPARATIVE_TABLE
                ]
            }
        ]
    },
    // Publishing
    {
        icon: 'publishing',
        locked: TIKTOK_PUBLISHING_HAS_ACCESS.read,
        link: {
            query: {
                [GLOBAL_EVENT_QUERY]: GLOBAL_EVENT_TYPES.TIKTOK_UPGRADE_API
            }
        },
        name: 'commons:menu.publishing',
        lockedTooltip: 'commons:menu.tooltips.old_plan_restricted_access',
        lockedLinks: {
            billing_link: (
                <LinkBase
                    href={{
                        pathname: SUBSCRIPTION_INVOICES,
                        query: { step: CHANGE_YOUR_PLAN }
                    }}
                    className="text-icoBlue underline"
                />
            )
        }
    },
    // Inspiration
    {
        icon: 'inspiration',
        link: INSPIRATION,
        name: 'commons:menu.inspiration'
    }
];

export default mainTiktok;
